"use strict"; // Adds Responsive Embeds to all iframe, objects and video tags
jQuery(document).ready(function() {
    jQuery('iframe[src*="youtube"]').each(function() {
        jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    });
});